<template>
  <div
    class="lego-date-picker lego-input"
    :class="datePickerClass"
    v-picker-click-outside="onClickOutside"
  >
    <div class="datepicker-lite-multi" :class="{ 'show-flag': showPicker }">
      <lego-text-field
        ref="from-text"
        class="lego-date-picker__text-field"
        v-model="from.textInput"
        :mask="inputType.replace(/#/g, '%#').replace(/[ymd]/gi, '#')"
        :placeholder="noPlaceholder ? '' : inputType.toUpperCase()"
        :disabled="disabled"
        :readonly="readonly"
        :no-shake="noShake"
        @focus="onFocus(1)"
        @keydown.enter="(e) => onUpdate(1, e, false)"
        @keydown.tab="(e) => onUpdate(1, e, false)"
        @update:modelValue="changeFromInput"
        :rules="[validateFromInput]"
      />
      <lego-icon-wrapper> ~</lego-icon-wrapper>
      <lego-text-field
        ref="to-text"
        class="lego-date-picker__text-field"
        v-model="to.textInput"
        :mask="inputType.replace(/#/g, '%#').replace(/[ymd]/gi, '#')"
        :placeholder="noPlaceholder ? '' : inputType.toUpperCase()"
        :disabled="disabled"
        :readonly="readonly"
        :no-shake="noShake"
        tabindex="-1"
        @focus="onFocus(2)"
        @keydown.enter="(e) => onUpdate(2, e, false)"
        @keydown.tab="(e) => onUpdate(2, e, false)"
        @update:modelValue="changeToInput"
        :rules="[validateToInput]"
      />
      <lego-icon-wrapper
        v-if="!disabled && !readonly"
        class="lego-date-picker__icon-wrapper"
        @click="onClickIcon"
      >
        <lego-icon class="lego-date-picker__icon" icon="calendar" icon-type="df" size="16" />
      </lego-icon-wrapper>
    </div>
    <div
      v-if="messageShow"
      class="lego-date-picker__message lego-validator__message"
      :class="messageClass"
    >
      {{ messageShow }}
    </div>
    <div
      v-show="showPicker"
      class="lego-date-picker-calendar__group"
      :class="{ 'show-flag': showPicker, left: position === 'left', right: position === 'right' }"
    >
      <!--      start-date-->
      <div class="lego-date-picker__calendar">
        <div class="lego-date-picker__calendar__month-area">
          <lego-icon-wrapper :disable="disablePreviousMonthFirst" @click.stop="onClickPrevMonth(1)">
            <lego-icon icon-type="df" icon="arrow_down" :size="16" />
          </lego-icon-wrapper>
          <div class="lego-date-picker-header">
            <span
              class="lego-date-picker-type"
              @click="modeChange('month', 1)"
              v-show="viewModeFirst === 'day'"
            >
              {{ monthFilterFirst }}
            </span>
            <span
              class="lego-date-picker-type"
              @click="modeChange('year', 1)"
              v-show="viewModeFirst === 'day'"
            >
              {{ yearFilterFirst }}
            </span>

            <span
              class="lego-date-picker-type"
              @click="modeChange('year', 1)"
              v-show="viewModeFirst === 'month'"
            >
              {{ monthFilterFirst }}
            </span>
            <span
              class="lego-date-picker-type"
              @click="
                year ? modeChange('year', 1) : month ? modeChange('month', 1) : modeChange('day', 1)
              "
              v-show="viewModeFirst === 'year'"
            >
              {{ monthFilterFirst }}
            </span>
          </div>

          <lego-icon-wrapper :disable="disableNextMonthFirst" @click.stop="onClickNextMonth(1)">
            <lego-icon icon-type="df" icon="arrow_up" :size="16" />
          </lego-icon-wrapper>
        </div>

        <div v-if="viewModeFirst === 'year'" class="lego-date-picker__calendar__date-area">
          <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverYear = ''">
            <template v-for="(years, didx) in decadeCalendar(calendarMonthFirst, 1)" :key="didx">
              <div class="lego-date-picker__calendar__year__row">
                <div class="lego-date-picker__calendar__year__row-content">
                  <template v-for="(year, yidx) in years" :key="yidx">
                    <span
                      :class="yearClass(year, 1)"
                      @click.stop="onClickYear(year, 1)"
                      @mouseenter="hoverYear = year"
                      >{{ year }}</span
                    >
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div v-if="viewModeFirst === 'month'" class="lego-date-picker__calendar__date-area">
          <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverMonth = ''">
            <div
              v-for="(months, yidx) in yearCalendar()"
              :key="yidx"
              class="lego-date-picker__calendar__month__row"
            >
              <div class="lego-date-picker__calendar__month__row-content">
                <template v-for="(month, midx) in months" :key="midx">
                  <span
                    :class="monthClass(month, 1)"
                    @click.stop="onClickMonth(month, 1)"
                    @mouseenter="hoverMonth = month"
                    >{{ monthAbbr[month - 1] }}</span
                  >
                </template>
              </div>
            </div>
          </div>
        </div>

        <div v-if="viewModeFirst === 'day'" class="lego-date-picker__calendar__range-container">
          <div class="lego-date-picker__calendar__date-area">
            <div class="lego-date-picker__calendar__day lego-date-picker__calendar__row">
              <div class="lego-date-picker__calendar__row-background"></div>
              <div class="lego-date-picker__calendar__row-content">
                <template v-for="(day, idx) in weekDay" :key="idx">
                  <span :class="weekDayClass(idx)">{{ day.text }}</span>
                </template>
              </div>
            </div>
            <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverDate = ''">
              <template v-for="(week, wIdx) in monthCalendarFirst" :key="wIdx">
                <div class="lego-date-picker__calendar__week lego-date-picker__calendar__row">
                  <div class="lego-date-picker__calendar__row-background">
                    <template v-for="(date, dIdx) in week" :key="dIdx">
                      <div :class="date.rangeColor"></div>
                    </template>
                  </div>
                  <div class="lego-date-picker__calendar__row-content">
                    <template v-for="(date, dIdx) in week" :key="dIdx">
                      <span
                        :class="dateClass(date, dIdx)"
                        @click.stop="onClickDate(date, 1)"
                        @mouseenter="hoverDate = date.value"
                        >{{ date.text }}</span
                      >
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!--      end-date-->
      <div class="lego-date-picker__calendar">
        <div class="lego-date-picker__calendar__month-area">
          <lego-icon-wrapper
            :disable="disablePreviousMonthSecond"
            @click.stop="onClickPrevMonth(2)"
          >
            <lego-icon icon-type="df" icon="arrow_down" :size="16" />
          </lego-icon-wrapper>
          <div class="lego-date-picker-header">
            <span
              class="lego-date-picker-type"
              @click="modeChange('month', 2)"
              v-show="viewModeSecond === 'day'"
            >
              {{ monthFilterSecond }}
            </span>
            <span
              class="lego-date-picker-type"
              @click="modeChange('year', 2)"
              v-show="viewModeSecond === 'day'"
            >
              {{ yearFilterSecond }}
            </span>

            <span
              class="lego-date-picker-type"
              @click="modeChange('year', 2)"
              v-show="viewModeSecond === 'month'"
            >
              {{ monthFilterSecond }}
            </span>
            <span
              class="lego-date-picker-type"
              @click="
                year ? modeChange('year', 2) : month ? modeChange('month', 2) : modeChange('day', 2)
              "
              v-show="viewModeSecond === 'year'"
            >
              {{ monthFilterSecond }}
            </span>
          </div>

          <lego-icon-wrapper :disable="disableNextMonthSecond" @click.stop="onClickNextMonth(2)">
            <lego-icon icon-type="df" icon="arrow_up" :size="16" />
          </lego-icon-wrapper>
        </div>

        <div v-if="viewModeSecond === 'year'" class="lego-date-picker__calendar__date-area">
          <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverYear = ''">
            <template v-for="(years, didx) in decadeCalendar(calendarMonthSecond, 2)" :key="didx">
              <div class="lego-date-picker__calendar__year__row">
                <div class="lego-date-picker__calendar__year__row-content">
                  <template v-for="(year, yidx) in years" :key="yidx">
                    <span
                      :class="yearClass(year, 2)"
                      @click.stop="onClickYear(year, 2)"
                      @mouseenter="hoverYear = year"
                      >{{ year }}</span
                    >
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div v-if="viewModeSecond === 'month'" class="lego-date-picker__calendar__date-area">
          <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverMonth = ''">
            <div
              v-for="(months, yidx) in yearCalendar()"
              :key="yidx"
              class="lego-date-picker__calendar__month__row"
            >
              <div class="lego-date-picker__calendar__month__row-content">
                <template v-for="(month, midx) in months" :key="midx">
                  <span
                    :class="monthClass(month, 2)"
                    @click.stop="onClickMonth(month, 2)"
                    @mouseenter="hoverMonth = month"
                    >{{ monthAbbr[month - 1] }}</span
                  >
                </template>
              </div>
            </div>
          </div>
        </div>

        <div v-if="viewModeSecond === 'day'" class="lego-date-picker__calendar__range-container">
          <div class="lego-date-picker__calendar__date-area">
            <div class="lego-date-picker__calendar__day lego-date-picker__calendar__row">
              <div class="lego-date-picker__calendar__row-background"></div>
              <div class="lego-date-picker__calendar__row-content">
                <template v-for="(day, idx) in weekDay" :key="idx">
                  <span :class="weekDayClass(idx)">{{ day.text }}</span>
                </template>
              </div>
            </div>
            <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverDate = ''">
              <template v-for="(week, wIdx) in monthCalendarSecond" :key="wIdx">
                <div class="lego-date-picker__calendar__week lego-date-picker__calendar__row">
                  <div class="lego-date-picker__calendar__row-background">
                    <template v-for="(date, dIdx) in week" :key="dIdx">
                      <div :class="date.rangeColor"></div>
                    </template>
                  </div>
                  <div class="lego-date-picker__calendar__row-content">
                    <template v-for="(date, dIdx) in week" :key="dIdx">
                      <span
                        :class="dateClass(date, dIdx)"
                        @click.stop="onClickDate(date, 2)"
                        @mouseenter="hoverDate = date.value"
                        >{{ date.text }}</span
                      >
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import legoDatePicker from '@/lego-component/components/element/legoDatePicker/legoDatePicker.vue';
import { isUndefined } from 'lodash';

const DUMMY_EVENT = {
  preventDefault: () => {}
};

import i18nMixin from '@/mixins/i18n.mixin.js';
import dateTimeMixin from './mixins/dateTime.mixin.js';
import moment from 'moment';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';

const { dateFormat } = useDateTimeFormat();

export default {
  name: 'scpmDateRangePicker',
  extends: legoDatePicker,
  emits: ['disabledSearch', 'update:modelValue'],
  props: {
    month: {
      type: Boolean,
      default: false
    },
    year: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: [String, Object],
      default: dateFormat
    },
    modelType: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    readonly: { type: Boolean, default: false },
    range: {
      type: Boolean,
      default: true
    },
    minDate: {
      type: String,
      default: '1970-01-01'
    },
    maxDate: {
      type: String,
      default: '9999-12-31'
    },
    width: {
      type: String,
      default: '328px'
    },
    position: {
      type: String,
      default: 'left'
    }
  },
  mixins: [i18nMixin, dateTimeMixin],
  data() {
    return {
      default: {
        size: 'medium'
      },
      viewMode: 'day',
      viewModeFirst: 'day',
      viewModeSecond: 'day',
      calendarMonthFirst: [],
      calendarMonthSecond: [],
      weekDay: [
        { text: 'S', value: 'SUN' },
        { text: 'M', value: 'MON' },
        { text: 'T', value: 'TUE' },
        { text: 'W', value: 'WED' },
        { text: 'T', value: 'THU' },
        { text: 'F', value: 'FRI' },
        { text: 'S', value: 'SAT' }
      ],
      hoverMonth: '',
      hoverYear: '',
      calendarYearsFirst: [],
      calendarYearsSecond: [],
      viewType: 0,
      showPicker: false,
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

      minDateDefault: new Date(
        new Date(this.minDate).getFullYear(),
        new Date(this.minDate).getMonth()
      ),
      maxDateDefault: new Date(
        new Date(this.maxDate).getFullYear(),
        new Date(this.maxDate).getMonth()
      )
    };
  },
  mounted() {
    if (this.month) {
      this.viewModeFirst = 'month';
      this.viewModeSecond = 'month';
      this.viewMode = 'month';
    }
    if (this.year) {
      this.viewModeFirst = 'year';
      this.viewModeSecond = 'year';
      this.viewMode = 'year';
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        this.initDate(value);
      }
    }
  },
  created() {},
  computed: {
    monthFilterFirst() {
      switch (this.viewModeFirst) {
        case 'day':
          return this.monthAbbr[parseInt(this.calendarMonthFirst[1]) - 1];
        case 'month':
          return this.monthFilter(this.calendarMonthFirst, 1);
        case 'year':
          return this.monthFilter(this.calendarMonthFirst, 1);
        default:
          break;
      }
      return false;
    },
    yearFilterFirst() {
      switch (this.viewModeFirst) {
        case 'day':
          return this.monthFilter(this.calendarMonthFirst, 1);
        case 'month':
          return this.monthFilter(this.calendarMonthFirst, 1);
        case 'year':
          return this.monthFilter(this.calendarMonthFirst, 1);
        default:
          break;
      }
      return false;
    },
    monthFilterSecond() {
      switch (this.viewModeSecond) {
        case 'day':
          return this.monthAbbr[parseInt(this.calendarMonthSecond[1]) - 1];
        case 'month':
          return this.monthFilter(this.calendarMonthSecond, 2);
        case 'year':
          return this.monthFilter(this.calendarMonthSecond, 2);
        default:
          break;
      }
      return false;
    },
    yearFilterSecond() {
      switch (this.viewModeSecond) {
        case 'day':
          return this.calendarMonthSecond[0];
        case 'month':
          return this.monthFilter(this.calendarMonthSecond, 2);
        case 'year':
          return this.monthFilter(this.calendarMonthSecond, 2);
        default:
          break;
      }
      return false;
    },
    monthCalendarFirst() {
      return this.monthCalendar(this.calendarMonthFirst, 1);
    },
    monthCalendarSecond() {
      return this.monthCalendar(this.calendarMonthSecond, 2);
    },

    firstDateDefault() {
      return new Date(
        parseInt(this.calendarMonthFirst[0]),
        parseInt(this.calendarMonthFirst[1]) - 1
      );
    },
    secondDateDefault() {
      return new Date(
        parseInt(this.calendarMonthSecond[0]),
        parseInt(this.calendarMonthSecond[1]) - 1
      );
    },
    disablePreviousMonthFirst() {
      if (this.viewModeFirst === 'day') {
        return this.minDateDefault >= this.firstDateDefault;
      }
      return true;
    },
    disableNextMonthFirst() {
      if (this.viewModeFirst === 'day') {
        return moment(this.secondDateDefault).diff(this.firstDateDefault, 'month') <= 1;
      }
      return true;
    },
    disablePreviousMonthSecond() {
      if (this.viewModeFirst === 'day') {
        return moment(this.secondDateDefault).diff(this.firstDateDefault, 'month') <= 1;
      }
      return true;
    },
    disableNextMonthSecond() {
      if (this.viewModeFirst === 'day') {
        return this.maxDateDefault <= this.secondDateDefault;
      }
      return true;
    },
    yearValidate() {
      const years =
        this.calendarYearsFirst.length > 0 ? this.calendarYearsFirst : this.calendarYearsSecond;
      return years.filter(
        (y) => y > new Date(this.maxDate).getFullYear() || y < new Date(this.minDate).getFullYear()
      );
    },
    monthValidate() {
      return this.monthList.filter(
        (m) =>
          (m > new Date(this.maxDate).getMonth() + 1 ||
            m < new Date(this.minDate).getMonth() + 1) &&
          this.calendarMonthFirst[0] === this.calendarMonthSecond[0]
      );
    }
  },
  methods: {
    initDate(value) {
      if (!this.today) {
        this.currTime = new Date();
        this.today = this.dateToYmd(this.currTime);
      }
      let rtn, targetMonth, targetMonth1, targetMonth2, validVal;
      if (this.isRange) {
        validVal = this.toValidRange(value);
        if (this.from.actualDate !== validVal[0] || this.from.selected !== validVal[0]) {
          this.from.actualDate = validVal[0];
          this.from.textInput = this.ymdToText(
            this.from.actualDate,
            this.inputType.replace(/[^ymd]/gi, '')
          );
          this.from.selected = validVal[0];
        }
        if (this.to.actualDate !== validVal[1] || this.to.selected !== validVal[1]) {
          this.to.actualDate = validVal[1];
          this.to.textInput = this.ymdToText(
            this.to.actualDate,
            this.inputType.replace(/[^ymd]/gi, '')
          );
          this.to.selected = validVal[1];
        }
        if (validVal[1]) {
          targetMonth2 = validVal[1].split('-');
          // targetMonth[1] = parseInt(targetMonth[1]) - 1;
          targetMonth2[1] = parseInt(targetMonth2[1]);
        }
        if (validVal[0]) {
          targetMonth1 = validVal[0].split('-');
          targetMonth1[1] = parseInt(targetMonth1[1]);
        }

        if (!this.isEqualArray(this.presetVal, validVal)) this.presetName = '';
        rtn = [this.ymdToModel(validVal[0]), this.ymdToModel(validVal[1])];
        if (!this.isEqualArray(value, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else if (this.isMounted) {
          this.validateOnEvent();
        }
      }
      if (!targetMonth1 && !targetMonth2) {
        let date = this.today;
        if (date < this.minDate) {
          date = this.minDate;
        }
        if (date > this.maxDate) {
          date = this.maxDate;
        }
        targetMonth = date.split('-');
      }
      if (targetMonth) {
        this.setCalendarMonth([parseInt(targetMonth[0]), parseInt(targetMonth[1])], 1);
        this.setCalendarMonth([parseInt(targetMonth[0]), parseInt(targetMonth[1]) + 1], 2);
        return;
      }

      if (targetMonth1[1] === targetMonth2[1]) {
        this.setCalendarMonth([parseInt(targetMonth1[0]), parseInt(targetMonth1[1])], 1);
        this.setCalendarMonth([parseInt(targetMonth2[0]), parseInt(targetMonth2[1]) + 1], 2);
        return;
      }

      this.setCalendarMonth([parseInt(targetMonth1[0]), parseInt(targetMonth1[1])], 1);
      this.setCalendarMonth([parseInt(targetMonth2[0]), parseInt(targetMonth2[1])], 2);
    },
    makePrevDate(calendarMonth, flag) {
      let arr = [];
      // prev month's last few days
      let selMon = new Date(calendarMonth[0], calendarMonth[1] - 1);
      let idx = selMon.getDay();
      for (let i = 1 - idx; i < 1; i++) {
        let tmp = new Date(calendarMonth[0], calendarMonth[1] - 1, i);
        let value = this.dateToYmd(tmp);
        let state = 'prev',
          rangeColor = [];
        if (value < this.minDate) {
          state = 'disabled';
        }
        if (this.maxDate < value) {
          state = 'disabled';
        }
        if (this.showPicker) {
          if (flag === 2) {
            state = 'invisible';
          } else {
            rangeColor = this.makeRangeColor(
              value,
              this.from.selected,
              this.to.selected,
              this.hoverDate
            );
          }
        }
        arr.push({
          text: tmp.getDate(),
          value: value,
          state: state,
          rangeColor: rangeColor
        });
      }
      return [arr, idx];
    },
    makeCurrDate(calendarMonth, flag, arr, idx) {
      let rtn = [];
      let tmp = this.dateToYmd(new Date(calendarMonth[0], calendarMonth[1] - 1)).slice(0, 8);
      let maxDate =
        (new Date(calendarMonth[0], calendarMonth[1]) -
          new Date(calendarMonth[0], calendarMonth[1] - 1)) /
        24 /
        60 /
        60 /
        1000;
      for (let i = 1; i <= maxDate; i++) {
        let value = tmp + (i < 10 ? '0' + i : i);
        let state = false,
          rangeColor = [];
        if (value < this.minDate) {
          state = 'disabled';
        }
        if (this.maxDate < value) {
          state = 'disabled';
        }
        if (this.showPicker) {
          rangeColor = this.makeRangeColor(
            value,
            this.from.selected,
            this.to.selected,
            this.hoverDate
          );
        }
        arr.push({
          text: i,
          value: value,
          state: state,
          rangeColor: rangeColor
        });
        if (idx === 6) {
          idx = 0;
          rtn.push(arr);
          arr = [];
        } else {
          idx++;
        }
      }
      return [rtn, arr, idx];
    },
    makeNextDate(calendarMonth, flag, rtn, arr, idx) {
      // next month's first few days
      for (let i = idx; i <= 6; i++) {
        let tmp = new Date(calendarMonth[0], calendarMonth[1], i - idx + 1);
        let value = this.dateToYmd(tmp);
        let state = 'next',
          rangeColor = [];
        if (value < this.minDate) {
          state = 'disabled';
        }
        if (this.maxDate < value) {
          state = 'disabled';
        }
        if (this.showPicker) {
          if (flag === 1) {
            state = 'invisible';
          } else {
            rangeColor = this.makeRangeColor(
              value,
              this.from.selected,
              this.to.selected,
              this.hoverDate
            );
          }
        }
        arr.push({
          text: tmp.getDate(),
          value: value,
          state: state,
          rangeColor: rangeColor
        });
      }
      rtn.push(arr);
      return rtn;
    },
    setViewMode(type, value) {
      if (type === 0) return;
      if (type === 1) {
        this.viewModeFirst = value;
      }
      if (type === 2) {
        this.viewModeSecond = value;
      }
    },
    getViewMode(type) {
      if (type === 0) return;
      if (type === 1) {
        return this.viewModeFirst;
      }
      if (type === 2) {
        return this.viewModeSecond;
      }
    },
    setCalendarMonthValue(type, value, index) {
      if (type === 0) return;
      if (isUndefined(index)) {
        if (type === 1) {
          this.calendarMonthFirst = value;
        }
        if (type === 2) {
          this.calendarMonthSecond = value;
        }
      } else {
        if (type === 1) {
          this.calendarMonthFirst[index] = value;
        }
        if (type === 2) {
          this.calendarMonthSecond[index] = value;
        }
      }
    },
    getCalendarMonthValue(type, index) {
      if (type === 1) {
        return this.calendarMonthFirst[index];
      }
      if (type === 2) {
        return this.calendarMonthSecond[index];
      }
      return '';
    },
    setCalendarYears(type = 0, value) {
      if (type === 0) return;
      if (type === 1) {
        this.calendarYearsFirst = [];
        this.calendarYearsFirst.push(...value);
      }
      if (type === 2) {
        this.calendarYearsSecond = [];
        this.calendarYearsSecond.push(...value);
      }
    },
    getCalendarYears(type = 0) {
      if (type === 0) return;
      if (type === 1) {
        return this.calendarYearsFirst;
      }
      if (type === 2) {
        return this.calendarYearsSecond;
      }
    },
    onFocus(idx) {
      if (idx === 1 && this.to.textInput) {
        this.to.selected = this.to.textInput;
        this.onUpdate(2, DUMMY_EVENT, false);
      }
      if (idx === 1 && !this.to.textInput) {
        this.to.selected = '';
        this.onUpdate(2, DUMMY_EVENT, false);
      }
      if (idx === 2 && this.from.textInput) {
        this.from.selected = this.from.textInput;
        this.onUpdate(1, DUMMY_EVENT, false);
      }
      if (idx === 2 && !this.from.textInput) {
        this.from.selected = '';
        this.onUpdate(1, DUMMY_EVENT, false);
      }
      if (idx === 2 && this.range && !this.from.selected) {
        this.$refs['from-text'].focus();
        return;
      }
      this.viewType = idx;
      this.showPicker = true;
    },
    onClickIcon() {
      if (this.disabled) return;
      if (this.range && !this.from.selected) {
        this.showPicker = !this.showPicker;
        this.viewType = 1;
        return;
      }
      if (this.range && !this.to.selected) {
        this.showPicker = !this.showPicker;
        this.viewType = 2;
        return;
      }
      this.viewType = 3;
      this.showPicker = !this.showPicker;
    },
    inputToYmd(input) {
      if (!input || typeof input !== 'string') {
        return '';
      }
      let inputFormat = this.inputType.replace(/[^ymd]/gi, '').toUpperCase();
      let sIdx = inputFormat.indexOf('Y');
      let y4Flag = inputFormat.indexOf('YYYY') !== -1;
      let YYYY = '',
        tmp = '';
      if (input.length === 4) {
        // no YYYY or YY
        if (y4Flag) {
          YYYY = input;
          if (this.viewMode === 'month') {
            tmp = YYYY + '01';
          } else if (this.viewMode === 'year') {
            tmp = YYYY;
          } else {
            tmp = YYYY + '0101';
          }
        } else {
          tmp = input.slice(0, sIdx) + YYYY.slice(2) + input.slice(sIdx);
        }
      } else if (input.length === 6) {
        // YY
        if (y4Flag) {
          // YYYY = input.slice(sIdx, sIdx + 2);
          // YYYY = parseInt(YYYY) < 70 ? '20' + YYYY : '19' + YYYY;
          YYYY = input.slice(sIdx, sIdx + 4);
          if (this.viewMode === 'month') {
            tmp = YYYY + input.slice(4);
          } else {
            tmp = YYYY + input.slice(4) + '01';
          }
        } else {
          tmp = input;
        }
      } else if (input.length === 8) {
        // YYYY
        if (y4Flag) {
          tmp = input;
        } else {
          YYYY = input.slice(sIdx, sIdx + 4);
          tmp = input.slice(0, sIdx) + YYYY.slice(2) + input.slice(sIdx + 4);
        }
      } else {
        return '';
      }
      return this.textToYmd(tmp, inputFormat);
    },
    validateInputDate(input) {
      const regex = /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/;

      const replaceKrCb = (match, year, month, day) => {
        month = month.padStart(2, '0');
        day = day.padStart(2, '0');
        return `${year}${month}${day}`;
      };

      const replaceEnCb = (match, month, day, year) => {
        const today = new Date();
        if (match.length === 4) {
          month = year.substring(0, 2);
          day = year.substring(2, 4);
          year = today.getFullYear();
        }

        return `${month}${day}${year}`;
      };

      const regexFormatDate = {
        'YYYY-MM-DD': { regex: /^(\d{4})(\d{0,2})(\d{0,2})$/, callback: replaceKrCb },
        'MM-DD-YYYY': { regex: /^(\d{0,2})(\d{0,2})(\d{4})$/, callback: replaceEnCb }
      };

      if (regex.test(input) && input.length === 8) {
        return input;
      }

      if (dateFormat === 'MM-DD-YYYY') {
        switch (true) {
          case input.length === 1:
            input = input.padStart(2, '0') + '01';
            break;
          case input.length === 2:
            input = input + '01';
            break;
          case input.length === 3:
            input = input.slice(0, 2) + '0' + input.slice(2);
            break;

          default:
            break;
        }
      }

      let date = input.replace(
        regexFormatDate[dateFormat].regex,
        regexFormatDate[dateFormat].callback
      );

      return date;
    },
    onUpdate(idx, tabEvent = DUMMY_EVENT, focusTo = true) {
      if (tabEvent.shiftKey) {
        if (idx === 1) this.from.textInput = this.ymdToInput(this.from.actualDate);
        this.showPicker = false;
        return;
      }
      if (['Enter', 'Tab'].includes(tabEvent.key)) {
        if (idx === 1) {
          if (this.to.textInput) {
            this.$refs['from-text'].blur();
          } else {
            this.$refs['to-text'].focus();
          }
        }

        if (idx === 2) {
          if (this.from.textInput) {
            this.$refs['to-text'].blur();
          }
        }
      }
      // textInput is updated
      let tmp,
        rtn = ['', ''],
        newValue;
      if (this.isRange && idx === 1) {
        // range date picker && on update 'from' text
        newValue = this.inputToYmd(this.validateInputDate(this.from.textInput));
        if (newValue !== '') {
          newValue = this.toValidYmd(newValue);
          // proper input received
          this.setFromTextInput(newValue);

          //Check from date valur more than to date, reset to date equal from date value
          const fromDate = moment(this.from.selected);
          const toDate = moment(this.to.selected);
          if (toDate.diff(fromDate) < 0) {
            this.to.textInput = fromDate.format(this.inputType);
            this.to.selected = fromDate.format(this.inputType);
          }
          if (focusTo) {
            this.$refs['to-text'].focus();
          }
          tabEvent.preventDefault();
          this.onConfirm();
          return;
        }
        if (this.from.textInput) {
          // intend to input some date text but not valid -> restore text same as actualDate
          this.from.textInput = this.ymdToInput(this.from.actualDate);
          tabEvent.preventDefault();
          return;
        }
        if (!this.strictRange) {
          // empty input but want to enter 'to' date first. (only when strictRange false)
          // strictRange true -> not allow to input 'to' date before 'from' date confirmed.
          this.from.selected = '';
          if (focusTo) {
            this.$refs['to-text'].focus();
          }
          tabEvent.preventDefault();
          return;
        }
        // strictRange true
        if (!this.isEqualArray(rtn, [this.from.selected, this.to.selected])) {
          // when strictRange true, empty input make selected date clear.
          this.from.selected = '';
          this.to.selected = '';
          tabEvent.preventDefault();
          return;
        }
        // already clear, update v-model & close calendar
        this.onConfirm();
      } else if (!this.isRange) {
        // single date picker
        newValue = this.inputToYmd(this.from.textInput);
        if (newValue !== '') {
          newValue = this.toValidYmd(newValue);
          // proper input received
          if (newValue !== this.from.selected) {
            // change selected date same as input
            this.setFromTextInput(newValue);
            tabEvent.preventDefault();
          }
          this.onConfirm();
          // if selected date is already set, update v-model & close calendar
          return; // not execute e.preventDefault
        } else if (this.from.textInput) {
          // intend to input some date text but not valid -> restore text same as actualDate
          this.from.textInput = this.ymdToInput(this.from.actualDate);
          tabEvent.preventDefault();
          return;
        } else if (this.from.selected) {
          // empty input
          this.from.selected = '';
          tabEvent.preventDefault();
          return;
        }
        // already clear, update v-model & close calendar
        this.onConfirm();
      } else {
        // idx = 2
        // range date picker && on update 'to' text
        newValue = this.inputToYmd(this.validateInputDate(this.to.textInput));
        newValue = this.toValidYmd(newValue);
        if (newValue !== '' && this.strictRange) {
          // proper input received & strictRange true
          if (!this.from.selected) {
            // strictRange true -> not allow to input 'to' date before 'from' date confirmed.
            if (focusTo) {
              this.$refs['to-text'].focus();
            }
            tabEvent.preventDefault();
            return;
          }
          if (this.from.selected > newValue) {
            // 'to' date input is earlier than 'from' date -> update 'from' date as received input.
            this.setFromTextInput(newValue);
            this.to.textInput = '';
            this.to.selected = '';
            tabEvent.preventDefault();
            return;
          }
          if (newValue !== this.to.selected) {
            // update selected 'to' date as received input.
            this.to.textInput = this.ymdToInput(newValue);
            this.to.selected = newValue;
            tmp = this.to.selected.split('-');

            if (!this.isEqualArray(this.calendarMonth, [parseInt(tmp[0]), parseInt(tmp[1])])) {
              tmp = this.dateToYmd(this.ymdToDate(this.to.selected, 0, 0, 0)).split('-');
              this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
            }
            tabEvent.preventDefault();
            return;
          }
          // selected date already updated, update v-model & close calendar
          this.onConfirm();
          return; // not execute e.preventDefault
        } else if (newValue !== '' && newValue !== this.to.selected) {
          // proper input received & strictRange false -> make selected 'to' date as received input
          const fromDate = moment(this.from.selected);
          const toDate = moment(newValue);
          if (toDate.diff(fromDate) < 0) {
            this.to.textInput = fromDate.format(this.inputType);
            this.to.selected = fromDate.format(this.inputType);
          } else {
            this.to.textInput = this.ymdToInput(newValue);
            this.to.selected = newValue;
          }
          this.setToTextInput();
          if (focusTo) {
            this.$refs['to-text'].focus();
          }
          tabEvent.preventDefault();
          this.onConfirm();
          return;
        } else if (newValue !== '') {
          // proper input received & strictRange false & selected 'to' date already updated
          // -> update v-model & close calendar
          const fromDate = moment(this.from.selected);
          const toDate = moment(newValue);
          this.to.textInput = this.ymdToInput(newValue);
          if (toDate.diff(fromDate) < 0) {
            this.to.textInput = fromDate.format(this.inputType);
            this.to.selected = fromDate.format(this.inputType);
          }
          if (focusTo) {
            this.$refs['to-text'].focus();
          }
          this.onConfirm();
          return; // not execute e.preventDefault
        } else if (this.to.textInput) {
          // intend to input some date text but not valid -> restore text same as actualDate
          this.to.textInput = this.ymdToInput(this.to.actualDate);
          tabEvent.preventDefault();
          return;
        } else if (this.strictRange || this.to.selected) {
          // empty input recieved -> clear selected 'to' date
          this.to.selected = '';
          tabEvent.preventDefault();
          this.onConfirm();
          return;
        }
        // selected 'to' date already cleared & strictRange is false -> update v-model & close calendar
        this.onConfirm(); // not execute e.preventDefault
      }
    },
    ymdToText(val, textFormat) {
      let tmp, rtn;
      // valid val?
      if (!val || typeof val !== 'string') {
        return '';
      }
      tmp = val.split('-');
      if (tmp.length !== 3) {
        return '';
      }
      rtn = textFormat.toUpperCase();
      rtn = rtn.replace('YYYY', tmp[0]);
      rtn = rtn.replace('YY', tmp[0].slice(2));
      rtn = rtn.replace('MM', tmp[1]);
      rtn = rtn.replace('DD', tmp[2]);
      return rtn;
    },
    async onClickDate(date, type) {
      if (date.state === 'prev') {
        this.onClickPrevMonth(type);
      } else if (date.state === 'next') {
        this.onClickNextMonth(type);
      }
      if (this.from.textInput && this.to.textInput && this.viewType === 3) {
        this.from.textInput = '';
        this.from.seleted = '';
        this.to.selected = '';
        this.to.textInput = '';
        this.viewType = 1;
      }
      if (this.viewType === 1) {
        this.from.textInput = this.ymdToInput(date.value);
        this.from.selected = date.value;
        if (this.to.selected && date.value < this.to.selected) {
          await this.onConfirm();
        } else if (this.to.selected && date.value > this.to.selected) {
          this.to.textInput = this.ymdToInput(date.value);
          this.to.selected = date.value;
          await this.onConfirm();
        } else this.viewType = 2;
      } else if (this.viewType === 2) {
        if (this.from.selected) {
          if (date.value < this.from.selected) {
            this.to.textInput = this.ymdToInput(this.from.selected);
            this.to.selected = this.from.selected;
          } else {
            this.to.textInput = this.ymdToInput(date.value);
            this.to.selected = date.value;
          }
        } else if (this.to.selected) {
          if (this.to.selected < date.value) {
            this.to.textInput = this.ymdToInput(date.value);
            this.to.selected = date.value;
          } else {
            this.from.textInput = this.ymdToInput(date.value);
            this.from.selected = date.value;
          }
        } else {
          this.to.textInput = this.ymdToInput(date.value);
          this.to.selected = date.value;
        }
        if (this.to.selected && this.from.selected) this.onConfirm();
      }
    },
    isValidRange(from, to) {
      return from <= to;
    },
    validateFromInput(newInput) {
      const newDate = this.convertDate(newInput);
      if (newDate) {
        const validVal = this.toValidRange([newDate, this.to.selected]);
        if (this.to.selected && !this.isValidRange(newDate, this.to.selected)) {
          this.to.selected = validVal[0];
        }
      }
      if (this.isRange) {
        const rtn = [this.ymdToModel(newDate), this.ymdToModel(this.to.selected)];
        this.from.textInput = this.ymdToInput(newDate);
        this.$emit('update:modelValue', rtn);
      }
      return true;
    },
    validateToInput(newInput) {
      let newDate = this.convertDate(newInput);
      if (newDate) {
        const validVal = this.toValidRange([this.from.selected, newDate]);
        if (!this.isValidRange(this.from.selected, newDate)) {
          newDate = validVal[1];
        }
      }
      if (this.isRange) {
        const rtn = [this.ymdToModel(this.from.selected), this.ymdToModel(newDate)];
        this.to.textInput = this.ymdToInput(newDate);
        this.$emit('update:modelValue', rtn);
      }
      return true;
    },
    convertDate(newInput) {
      let newDate = this.inputToYmd(this.validateInputDate(newInput));
      return this.toValidYmd(newDate);
    },
    changeFromInput() {
      this.checkChangeInputDate();
    },
    changeToInput() {
      this.checkChangeInputDate();
    },
    checkChangeInputDate() {
      const startDate = this.convertDate(this.from.textInput);
      const endDate = this.convertDate(this.to.textInput);

      if (!this.isRange) return;

      this.$emit('disabledSearch', !this.isValidRange(startDate, endDate));
    },
    async onConfirm() {
      // selected confirmed and want to be update v-model & actual date
      // close calendar
      let rtn;
      if (this.isRange) {
        rtn = [this.ymdToModel(this.from.selected), this.ymdToModel(this.to.selected)];
        if (!this.isEqualArray(this.modelValue, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else {
          this.validateOnEvent();
        }
      } else {
        rtn = this.ymdToModel(this.from.selected);
        if (!this.isEqualModel(this.modelValue, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else {
          this.validateOnEvent();
        }
      }
      if (this.from.textInput && this.to.textInput) {
        this.showPicker = false;
      }
    },
    setCalendarMonth(calendarMonth, type = 0) {
      let YYYY, MM;
      if (Array.isArray(calendarMonth) && calendarMonth.length === 2) {
        this.setCalendarMonthValue(type, []);
        YYYY = parseInt(calendarMonth[0]);
        MM = parseInt(calendarMonth[1]);
        if (MM < 1) {
          YYYY -= 1;
          MM += 12;
        }
        if (MM > 12) {
          YYYY += 1;
          MM -= 12;
        }
        if (type !== 0) {
          this.setCalendarMonthValue(type, [YYYY, MM]);
        }
      }
    },
    onClickOutside() {
      if (!this.from.textInput || !this.to.textInput) {
        this.from.textInput = '';
        this.from.selected = '';
        this.to.textInput = '';
        this.to.selected = '';
        this.showPicker = false;
        this.onConfirm();
        return;
      }
      if (!this.showPicker) {
        return;
      }
      this.onUpdate(this.viewType, DUMMY_EVENT, false);
      this.showPicker = false;
      if (this.$refs['from-text']) {
        this.$refs['from-text'].blur();
      }
      if (this.$refs['to-text']) {
        this.$refs['to-text'].blur();
      }
      if (window.getSelection()) {
        window.getSelection().removeAllRanges();
      }
    },
    onClickPrevMonth(type = 0) {
      if (type === 0) return;
      if (this.getViewMode(type) === 'year') {
        this.setCalendarMonth(
          [
            parseInt(this.getCalendarMonthValue(type, 0)) - 1,
            parseInt(this.getCalendarMonthValue(type, 1))
          ],
          type
        );
      } else if (this.getViewMode(type) === 'month') {
        this.setCalendarMonth(
          [
            parseInt(this.getCalendarMonthValue(type, 0)) - 1,
            parseInt(this.getCalendarMonthValue(type, 1))
          ],
          type
        );
      } else {
        this.setCalendarMonth(
          [
            parseInt(this.getCalendarMonthValue(type, 0)),
            parseInt(this.getCalendarMonthValue(type, 1)) - 1
          ],
          type
        );
      }
    },
    onClickNextMonth(type = 0) {
      if (type === 0) return;
      if (this.getViewMode(type) === 'year') {
        this.setCalendarMonth(
          [
            parseInt(this.getCalendarMonthValue(type, 0)) + 1,
            parseInt(this.getCalendarMonthValue(type, 1))
          ],
          type
        );
      } else if (this.getViewMode(type) === 'month') {
        this.setCalendarMonth(
          [
            parseInt(this.getCalendarMonthValue(type, 0)) + 1,
            parseInt(this.getCalendarMonthValue(type, 1))
          ],
          type
        );
      } else {
        this.setCalendarMonth(
          [
            parseInt(this.getCalendarMonthValue(type, 0)),
            parseInt(this.getCalendarMonthValue(type, 1)) + 1
          ],
          type
        );
      }
    },
    monthFilter(month, type) {
      let m = parseInt(month[1]);
      let y = parseInt(month[0]);
      if (m < 0) {
        m = m + 12;
        y = y - 1;
      } else if (m > 12) {
        m = m - 12;
        y = y + 1;
      }
      m = m < 0 ? m + 12 : m > 11 ? m - 12 : m;
      switch (this.getViewMode(type)) {
        case 'year':
          const minYear = Math.min(...this.getCalendarYears(type)) || y;
          const maxYear = Math.max(...this.getCalendarYears(type)) || y;
          return `${minYear} - ${maxYear}`;
        default:
          return y;
      }
    },
    decadeCalendar(calendarMonth, type) {
      let rtn = [],
        tmp = [];
      let yStr = String(calendarMonth[0]);
      let yyFrom = Number(yStr.slice(0, 3) + '0');
      let len = 10;
      for (let a = 0; a < len; a++) {
        tmp.push(yyFrom + a);
        if (a % 3 == 2) {
          rtn.push(tmp);
          tmp = [];
        }
      }
      if (tmp.length) {
        rtn.push(tmp);
      }
      this.setCalendarYears(type, rtn.flat(Infinity));
      return rtn;
    },
    yearCalendar() {
      return [
        [1, 2, 3],
        [4, 5, 6],
        [7, 8, 9],
        [10, 11, 12]
      ];
    },
    monthClass(month, type = 0, year) {
      if (type === 0) return;
      let rtn = [];
      rtn.push('lego-date-picker__calendar__month');
      if (
        month === parseInt(this.getCalendarMonthValue(type, 1)) &&
        parseInt(this.getCalendarMonthValue(type, 0)) === new Date(this.currTime).getFullYear()
      )
        rtn.push(`lego-date-picker__calendar__month--selected`);
      if (month === this.hoverMonth) rtn.push('lego-date-picker__calendar__month--hover');
      if (
        this.monthValidate.some((m) => m === month) ||
        parseInt(this.getCalendarMonthValue(type, 0)) > new Date(this.maxDate).getFullYear()
      ) {
        rtn.push('lego-date-picker__calendar__month--disable');
      }

      return rtn;
    },
    yearClass(year, type = 0) {
      let rtn = [];
      rtn.push('lego-date-picker__calendar__year');
      if (year === parseInt(this.getCalendarMonthValue(type, 0)))
        rtn.push('lego-date-picker__calendar__year--selected');
      if (year === this.hoverYear) rtn.push('lego-date-picker__calendar__year--hover');
      if (this.yearValidate.some((y) => y === year)) {
        rtn.push('lego-date-picker__calendar__year--disable');
      }
      return rtn;
    },
    modeChange(val, type = 0) {
      this.setViewMode(type, val);
    },
    onClickMonth(month, type = 0) {
      this.setCalendarMonthValue(type, month, 1);
      this.setCalendarMonth(
        [
          parseInt(this.getCalendarMonthValue(type, 0)),
          parseInt(this.getCalendarMonthValue(type, 1))
        ],
        type
      );
      this.modeChange('day', type);
    },
    onClickYear(year, type = 0) {
      this.setCalendarMonthValue(type, year, 0);
      this.setCalendarMonth(
        [
          parseInt(this.getCalendarMonthValue(type, 0)),
          parseInt(this.getCalendarMonthValue(type, 1))
        ],
        type
      );
      this.modeChange('month', type);
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin lego-date-picker-calendar {
  &__calendar {
    &__date {
      @include font(14px);
    }
  }
  top: unset;
  position: unset;
  border: unset;
  padding: 0;
  &__row-content {
    span {
      @include font(12px, 700);
      color: $color--ui01;

      &.lego-date-picker__calendar__date.lego-date-picker__calendar__date--other-month,
      &.lego-date-picker__calendar__date.lego-date-picker__calendar__date--disabled {
        opacity: 0.2;
      }

      &.lego-date-picker__calendar__date--sunday {
        color: $color--status-error;
      }

      &.lego-date-picker__calendar__date {
        @include font(12px, 400);
      }

      &.lego-date-picker__calendar__date--today {
        color: $color--primary;
      }

      &.lego-date-picker__calendar__date--selected {
        color: $color--ui-white;
        @include font(12px, 700);
      }
    }
  }
  &__date {
    &-area {
      flex: 0 0 220px;
      margin-bottom: 0px;
    }
  }

  &__month__row {
    position: relative;
    height: 48px;
    width: 100%;
    margin-bottom: 8px;
    padding: 0 12px;
  }

  &__month__row-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    float: left;

    span {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      flex: 0 0 auto;
      border-radius: 50%;
      margin: 0 12px;
      @include font(14px);
    }
  }

  &__month {
    cursor: pointer;

    &:hover {
      color: $lego__font-color--default;
      background-color: $color--ui-10;
    }

    &.lego-date-picker__calendar__month--selected {
      color: $color--ui-white;
      background-color: $color--primary;
    }

    &.lego-date-picker__calendar__month--disable {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  &__year__row {
    position: relative;
    height: 48px;
    width: 100%;
    margin-bottom: 8px;
  }

  &__year__row-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    float: left;

    span {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      flex: 0 0 auto;
      border-radius: 50%;
      margin: 0 12px;
      outline: none;
      @include font(13px);
    }
  }

  &__year {
    cursor: pointer;

    &:hover {
      color: $lego__font-color--default;
      background-color: $color--ui-10;
    }

    &.lego-date-picker__calendar__year--selected {
      color: $color--ui-white;
      background-color: $color--primary;
    }

    &.lego-date-picker__calendar__year--disable {
      opacity: 0.4;
      pointer-events: none;
    }
  }
  .lego-date-picker__calendar__date-area {
    .lego-date-picker__calendar__row {
      margin-bottom: 2px;
    }
  }
}

.lego-date-picker {
  &__calendar--range {
    .lego-date-picker__calendar__month-area {
      justify-content: space-between;
    }

    left: 155px;
  }

  &-header {
    .lego-date-picker-type {
      @include font(16px, 700);
      color: $color--primary;

      &:hover {
        text-decoration: underline;
      }

      &:nth-of-type(2) {
        margin-left: 8px;
      }
    }
  }

  &-type {
    cursor: pointer;
  }

  &__text-field {
    width: 127px !important;
    min-width: 127px;
  }

  .lego-date-picker-calendar__group {
    width: 489px;
    position: absolute;
    top: 100%;
    bottom: auto;
    display: flex;
    column-gap: 10px;
    border: 1px solid;
    z-index: 100;
    height: 279px;
    padding: 12px;
    background-color: rgba(255, 255, 255, 1);

    &.show-flag {
      border-color: $color--primary;
    }

    &.left {
      left: 0;
    }

    &.right {
      right: 0;
    }

    .lego-date-picker__calendar {
      flex: 0 0 220px;
      width: 220px;
      min-height: 252px;
      @include lego-date-picker-calendar;

      .lego-date-picker__calendar__month-area {
        margin-bottom: 8px;
      }
    }
  }

  .lego-date-picker__icon-wrapper {
    border-left: 0;
  }

  &.lego-date-picker--medium {
    .lego-icon-wrapper {
      width: 30px;
      height: 30px;
    }
  }

  .datepicker-lite-multi {
    position: relative;
    width: v-bind(width);
    border: 1px solid var(--color-ui-ui06);
    gap: 0px;
    grid-template-columns: 105px 32px 105px 1fr;
    display: grid;
    border-radius: 2px;
    &:hover {
      border-color: $color--primary;
    }

    &.show-flag {
      border-color: $color--primary;
    }

    .lego-date-picker__text-field {
      width: 105px !important;
      min-width: 105px !important;

      :deep(.lego-text-field__input) {
        border: 0;
        cursor: pointer;
      }
    }

    .lego-date-picker__icon-wrapper {
      position: absolute;
      right: 8px;
    }
  }
}
</style>
